// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Color definitions for the app
 */

:root {
  --countdown: 100%;
}

.display-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2001;
}
.display-player .display-player-content.player-empty {
  max-height: 634px;
}
.display-player .display-player-content {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  bottom: 50%;
  margin: auto;
  border-radius: 8px;
  width: 840px;
  /* height: 862px; */
  height: calc(100% - 184px);
  max-height: 866px;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #FFFFFF;
}
.display-player .display-player-content .current-item-timer {
  position: absolute;
  top: 203px;
  right: 16px;
  color: #FFFFFF;
  font-size: 32px;
}
.display-player .display-player-content .options-container {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}
.display-player .display-player-content .options-container .option-item {
  flex: 1;
}
.display-player .display-player-content .display-player-header {
  position: relative;
  width: 100%;
  margin-bottom: 16px;
}
.display-player .display-player-content .display-player-header .display-player-title {
  color: #333F48;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.display-player .display-player-content .display-player-header .display-player-filename {
  color: #333F48;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 8px;
  width: 60%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.display-player .display-player-content .display-player-media {
  display: flex;
  position: relative;
  width: 792px;
  max-height: 496px;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 6px;
  background-color: #000000;
}
.display-player .display-player-content .display-player-media [data-vjs-player] {
  display: flex;
  justify-content: center;
  width: 100%;
}
.display-player .display-player-content .display-player-media .video-js {
  width: auto !important;
  height: auto !important;
  max-width: 100%;
  max-height: 496px;
}
.display-player .display-player-content .display-player-media .video-js .vjs-tech {
  position: relative;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 496px;
  object-fit: contain;
}
.display-player .display-player-content .selected-resolution-message {
  display: flex;
  position: relative;
  height: 445px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 6px;
  background: rgba(51, 63, 72, 0.15);
  color: #333F48;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
}
.display-player .display-player-content .display-player-progress-bar {
  position: absolute;
  display: flex;
  min-height: 36px;
  width: 720px;
  bottom: 30px;
  background-color: #333F48;
  border-radius: 8px;
}
.display-player .display-player-content .display-player-progress-bar .seconds-hovered {
  display: flex;
  height: 88px;
  width: 165px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #FFF;
  background: rgba(51, 63, 72, 0.1);
  position: absolute;
  top: -94px;
  left: 0;
}
.display-player .display-player-content .display-player-progress-bar .seconds-hovered .hover-image {
  display: block;
  position: relative;
  margin: 0 auto;
  height: 86px;
}
.display-player .display-player-content .display-player-progress-bar .seconds-hovered .seconds-hovered-time {
  display: flex;
  position: absolute;
  bottom: 0;
  padding: 4px 12px;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #FFF;
  background: #EAECF0;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.25);
  color: #151010;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 14px */
  z-index: 10;
}
.display-player .display-player-content .display-player-progress-bar .hover-dot {
  position: absolute;
  top: 11px;
  height: 12px;
  width: 12px;
  margin-left: 77px;
  background-color: #fff;
  border-radius: 50%;
  z-index: 100;
  pointer-events: none;
}
.display-player .display-player-content .display-player-progress-bar .display-player-button {
  width: 24px;
  height: 24px;
  margin-top: 6px;
  margin-left: 10px;
  margin-right: 6px;
  cursor: pointer;
}
.display-player .display-player-content .display-player-progress-bar .display-progress-bar {
  width: 565px;
  height: 8px !important;
}
.display-player .display-player-content .display-player-progress-bar .slider-wrapper {
  margin-top: 13px;
  width: 565px;
  height: 8px !important;
}
.display-player .display-player-content .display-player-progress-bar .display-progress-bar:hover {
  background: transparent;
}
.display-player .display-player-content .display-player-progress-bar .slider-track {
  height: 8px;
  background: #FFFFFF;
  border: 1px solid #FFFFFF;
}
.display-player .display-player-content .display-player-progress-bar .slider-thumb {
  background: #FFFFFF;
  color: #FFFFFF;
  box-shadow: none;
}
.display-player .display-player-content .display-player-progress-bar .slider-thumb::before {
  box-shadow: none;
}
.display-player .display-player-content .display-player-progress-bar .slider-rail {
  height: 8px !important;
  background: rgba(255, 255, 255, 0.5);
}
.display-player .display-player-content .display-player-progress-bar .loop-time-remaining {
  color: #FFFFFF;
  font-size: 12px;
  margin-top: 12px;
  margin-right: 14px;
  margin-left: 2px;
}
.display-player .display-player-content .display-player-progress-bar .loop-total-time {
  color: #FFFFFF;
  font-size: 12px;
  margin-top: 12px;
  margin-left: 14px;
}
.display-player .display-player-content .loop-media-navigation {
  display: flex;
  min-height: 34px;
  margin-top: 16px;
  margin-bottom: 16px;
}
.display-player .display-player-content .loop-media-navigation .loop-right-button {
  color: #333F48;
  margin-left: auto;
  cursor: pointer;
}
.display-player .display-player-content .loop-media-carousel {
  position: relative;
  min-height: 93px;
}
.display-player .display-player-content .loop-media-carousel .carousel-item-padding {
  padding: 0 8px;
}
.display-player .display-player-content .loop-media-carousel .react-multi-carousel-item {
  max-width: 173px;
}
.display-player .display-player-content .loop-media-carousel .media-item-download {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  font-size: 12px;
  color: #333F48;
}
.display-player .display-player-content .loop-media-carousel .media-item-download > .label {
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.display-player .display-player-content .loop-media-carousel .loop-left-button {
  position: absolute;
  color: #333F48;
  left: 16px;
  top: 32px;
}
.display-player .display-player-content .loop-media-carousel .loop-right-button {
  position: absolute;
  color: #333F48;
  left: 800px;
  top: 32px;
}
.display-player .display-player-content .loop-media-carousel .carousel-button-group {
  position: absolute;
  width: 100%;
  top: 0;
  display: flex;
  justify-content: space-between;
}
.display-player .display-player-content .loop-media-carousel .carousel-button-group .loop-left-button {
  color: #333F48;
  margin-top: 30px;
  cursor: pointer;
}
.display-player .display-player-content .loop-media-carousel .carousel-button-group .loop-right-button {
  color: #333F48;
  margin-top: 30px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/sass/color.scss","webpack://./src/vibeguide/src/components/DisplayPlayer/DisplayPlayer.scss"],"names":[],"mappings":"AAAA;;EAAA;;ACEA;EACE,iBAAA;AAwFF;;AArFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAwFJ;AAtFI;EACE,iBAAA;AAwFN;AArFI;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EAEA,mBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBDXE;ACiGR;AApFM;EACG,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cDjBD;ECkBC,eAAA;AAsFT;AAnFM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAqFR;AAnFQ;EACE,OAAA;AAqFV;AAjFM;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;AAmFR;AAjFQ;EACE,cDvDA;ECwDA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAmFV;AAhFQ;EACE,cD/DA;ECgEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAkFV;AA9EI;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBDpEE;ACoJR;AA9EM;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AAgFR;AA5EM;EACE,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AA8ER;AAxEM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AA0ER;AAtEI;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;EACA,cD5HI;EC6HJ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAwEN;AArEI;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,yBDzII;EC0IJ,kBAAA;AAuEN;AArEM;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;AAuER;AArEQ;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAuEV;AApEQ;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,4CAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,WAAA;AAsEV;AAlEM;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;AAoER;AAjEM;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAmER;AAhEM;EACE,YAAA;EACA,sBAAA;AAkER;AA/DM;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;AAiER;AA9DM;EACE,uBAAA;AAgER;AA7DM;EACE,WAAA;EACA,mBD5MA;EC6MA,yBAAA;AA+DR;AA5DM;EACE,mBDjNA;ECkNA,cDlNA;ECmNA,gBAAA;AA8DR;AA3DM;EACE,gBAAA;AA6DR;AA1DM;EACE,sBAAA;EACA,oCAAA;AA4DR;AAzDM;EACE,cDhOA;ECiOA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AA2DR;AAxDM;EACE,cDxOA;ECyOA,eAAA;EACA,gBAAA;EACA,iBAAA;AA0DR;AAtDI;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAwDN;AAtDM;EACE,cDvQE;ECwQF,iBAAA;EACA,eAAA;AAwDR;AApDI;EACE,kBAAA;EACA,gBAAA;AAsDN;AApDM;EACE,cAAA;AAsDR;AAnDM;EACE,gBAAA;AAqDR;AAlDM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cDjSE;ACqVV;AAlDQ;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAoDV;AAhDM;EACE,kBAAA;EACA,cD7SE;EC8SF,UAAA;EACA,SAAA;AAkDR;AA/CM;EACE,kBAAA;EACA,cDpTE;ECqTF,WAAA;EACA,SAAA;AAiDR;AA9CM;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,aAAA;EACA,8BAAA;AAgDR;AA9CQ;EACE,cDjUA;ECkUA,gBAAA;EACA,eAAA;AAgDV;AA7CQ;EACE,cDvUA;ECwUA,gBAAA;EACA,eAAA;AA+CV","sourcesContent":["/**\n * Color definitions for the app\n */\n\n// Theme Colors\n$primary: #333F48;\n$secondary: #222732;\n$yellow: #FECF0C;\n$red: #E02D4F;\n$teal: #23CCC3;\n$orange: #F66733;\n$lightGray: #F6F6F6;\n$whiteSmoke: #E1E1E9;\n$manatee: #959AAD;\n$obsidian: #383838;\n\n// Status Colors\n$success: #00A474;\n$warning: #FFC107;\n$error: #CF0838;\n\n// Other Colors\n$white: #FFFFFF;\n$black: #000000;\n$gray: #757575;\n$darkGray: #A4A7B7;\n$mediumGray: #E0E0E0;\n$lighterGray: #E3E7F4;\n$lightSlateGray: #8A8FA3;\n$carrot: #FF892E;\n$lightSmoke: #F5F4F5;\n$graphBlue: #1570EF;\n$lightOrchid: #7F56D9;\n$rainboots: #3361E1;\n$royalBlue: #4085DE;\n$sushi: #95C653;\n\n// Component Colors\n$primaryButtonBackground: $yellow;\n$primaryButtonText: $primary;\n$secondaryButtonBackground: $primary;\n$secondaryButtonText: $white;\n$navigationText: #95A3AD;\n$scheduleMusic: #FCC7B3;\n$scheduleMessageBlock: $teal;\n$scheduleInterrupt: #1997A3;\n$scheduleLoop: $primary;\n\n// Variants: Theme Colors\n$primary16: rgba($primary, 0.16);\n$primary40: rgba($primary, 0.4);\n$primary50: rgba($primary, 0.5);\n$primary60: rgba($primary, 0.6);\n$secondary25: rgba($secondary, 0.25);\n$secondary50: rgba($secondary, 0.5);\n$secondary75: rgba($secondary, 0.75);\n$yellow16: rgba($yellow, 16%);\n$yellow25: rgba($yellow, 25%);\n$yellow75: rgba($yellow, 75%);\n$orange16: rgba($orange, 0.16);\n$orange32: rgba($orange, 0.32);\n$orange50: rgba($orange, 0.5);\n$orange75: rgba($orange, 0.75);\n$manatee16: rgba($manatee, 0.16);\n$manatee50: rgba($manatee, 0.5);\n\n// Variants: Status Colors\n$success10: rgba($success, 0.08);\n$success16: rgba($success, 0.16);\n$success75: rgba($success, 0.75);\n$warning50: rgba($warning, 0.5);\n$error10: rgba($error, 0.1);\n$error16: rgba($error, 0.16);\n$error20: rgba($error, 0.2);\n$error50: rgba($error, 0.5);\n$error75: rgba($error, 0.75);\n$error85: rgba($error, 0.85);\n\n// Variants: Other Colors\n$gray50: #F9FAFB;\n$gray200: #EAECF0;\n$gray300: #D0D5DD;\n$gray400: #98A2B3;\n$gray500: #667085;\n$gray700: #344054;\n$gray900: #101828;\n$carrot16: rgba($carrot, 0.16);\n$rainboots16: rgba($rainboots, 0.16);\n$royalBlue16: rgba($royalBlue, 0.16);\n\n// Box colors (for color picker)\n$boxRed: $red;\n$boxPink: #F57A7A;\n$boxOrange: $orange;\n$boxYellow: $yellow;\n$boxGreen: #95C653;\n$boxDarkGreen: #00A474;\n$boxBlue: #33ACE1;\n$boxDarkBlue: #3361E1;\n$boxPurple: #6D6DB5;\n$boxPurple16: rgba($boxPurple, 0.16);\n$boxDarkPurple: #332A4B;\n\n:export {\n  // Theme Colors\n  primary: $primary;\n  secondary: $secondary;\n  yellow: $yellow;\n  red: $red;\n  teal: $teal;\n  orange: $orange;\n  lightGray: $lightGray;\n  whiteSmoke: $whiteSmoke;\n  manatee: $manatee;\n  obsidian: $obsidian;\n\n  // Status Colors\n  success: $success;\n  warning: $warning;\n  error: $error;\n\n  // Other Colors\n  white: $white;\n  black: $black;\n  gray: $gray;\n  darkGray: $darkGray;\n  mediumGray: $mediumGray;\n  lighterGray: $lighterGray;\n  lightSlateGray: $lightSlateGray;\n  carrot: $carrot;\n  lightSmoke: $lightSmoke;\n  graphBlue: $graphBlue;\n  lightOrchid: $lightOrchid;\n  rainboots: $rainboots;\n  royalBlue: $royalBlue;\n  sushi: $sushi;\n\n  // Component Colors\n  primaryButtonBackground: $primaryButtonBackground;\n  primaryButtonText: $primaryButtonText;\n  secondaryButtonBackground: $secondaryButtonBackground;\n  secondaryButtonText: $secondaryButtonText;\n  navigationText: $navigationText;\n  scheduleMusic: $scheduleMusic;\n  scheduleMessageBlock: $scheduleMessageBlock;\n  scheduleInterrupt: $scheduleInterrupt;\n  scheduleLoop: $scheduleLoop;\n  \n  // Variants: Theme Colors\n  primary16: $primary16;\n  primary40: $primary40;\n  primary50: $primary50;\n  primary60: $primary60;\n  secondary25: $secondary25;\n  secondary50: $secondary50;\n  secondary75: $secondary75;\n  yellow16: $yellow16;\n  yellow25: $yellow25;\n  yellow75: $yellow75;\n  orange16: $orange16;\n  orange32: $orange32;\n  orange50: $orange50;\n  orange75: $orange75;\n  manatee16: $manatee16;\n  manatee50: $manatee50;\n\n  // Variants: Status Colors\n  success10: $success10;\n  success16: $success16;\n  success75: $success75;\n  warning50: $warning50;\n  error10: $error10;\n  error16: $error16;\n  error20: $error20;\n  error50: $error50;\n  error75: $error75;\n  error85: $error85;\n\n  // Variants: Other Colors\n  gray50: $gray50;\n  gray200: $gray200;\n  gray300: $gray300;\n  gray400: $gray400;\n  gray500: $gray500;\n  gray700: $gray700;\n  gray900: $gray900;\n  carrot16: $carrot16;\n  rainboots16: $rainboots16;\n  royalBlue16: $royalBlue16;\n  boxPurple16: $boxPurple16;\n\n  // Box colors (for color picker)\n  boxRed: $boxRed;\n  boxPink: $boxPink;\n  boxOrange: $boxOrange;\n  boxYellow: $boxYellow;\n  boxGreen: $boxGreen;\n  boxDarkGreen: $boxDarkGreen;\n  boxBlue: $boxBlue;\n  boxDarkBlue: $boxDarkBlue;\n  boxPurple: $boxPurple;\n  boxDarkPurple: $boxDarkPurple;\n}\n","@use '~vibeguide/sass/color.scss' as color;\n\n:root {\n  --countdown: 100%;\n}\n\n  .display-player {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 2001;\n\n    .display-player-content.player-empty {\n      max-height: 634px;\n    }\n    \n    .display-player-content {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 50%;\n      bottom: 50%;\n      margin: auto;\n      border-radius: 8px;\n      width: 840px;\n\n      /* height: 862px; */\n      height: calc(100% - 184px);\n      max-height: 866px;\n      overflow-x: hidden;\n      overflow-y: auto;\n      background-color: color.$white;\n\n      .current-item-timer {\n         position: absolute;\n         top: 203px;\n         right: 16px;\n         color: color.$white;\n         font-size: 32px;\n      }\n\n      .options-container {\n        display: flex;\n        align-items: center;\n        gap: 16px;\n        margin-bottom: 16px;\n\n        .option-item {\n          flex: 1;\n        }\n      }\n\n      .display-player-header {\n        position: relative;\n        width: 100%;\n        margin-bottom: 16px;\n\n        .display-player-title {\n          color: color.$primary;\n          font-size: 24px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: normal;\n        }\n  \n        .display-player-filename {\n          color: color.$primary;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 18px;\n          margin-bottom: 8px;\n          width: 60%;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n\n    .display-player-media {\n      display: flex;\n      position: relative;\n      width: 792px;\n      max-height: 496px;\n      overflow: hidden;\n      justify-content: center;\n      align-items: center;\n      flex-shrink: 0;\n      border-radius: 6px;\n      background-color: color.$black;\n\n      [data-vjs-player] {\n        display: flex;\n        justify-content: center;\n        width: 100%;\n      }\n\n      // Let the player wrap its content instead of forcing the source resolution.\n      .video-js {\n        width: auto !important;\n        height: auto !important;\n        max-width: 100%;\n        max-height: 496px;\n        // background: transparent;\n      }\n\n      // The actual <video> element: size intrinsically, but fit within the\n      // container width and a capped height (handles portrait videos).\n      .video-js .vjs-tech {\n        position: relative;\n        width: auto;\n        height: auto;\n        max-width: 100%;\n        max-height: 496px;\n        object-fit: contain;\n      }\n    }\n\n    .selected-resolution-message {\n      display: flex;\n      position: relative;\n      height: 445px;\n      justify-content: center;\n      align-items: center;\n      flex-shrink: 0;\n      border-radius: 6px;\n      background: rgba(51, 63, 72, 0.15);\n      color: color.$primary;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 24px; /* 150% */\n    }\n\n    .display-player-progress-bar {\n      position: absolute;\n      display: flex;\n      min-height: 36px;\n      width: 720px;\n      bottom: 30px;\n      background-color: color.$primary;\n      border-radius: 8px;\n\n      .seconds-hovered {\n        display: flex;\n        height: 88px;\n        width: 165px;\n        justify-content: center;\n        align-items: center;\n        align-self: stretch;\n        border-radius: 4px;\n        border: 1px solid #FFF;\n        background: rgba(51, 63, 72, 0.10);\n        position: absolute;\n        top: -94px;\n        left: 0;\n\n        .hover-image {\n          display: block;\n          position: relative;\n          margin: 0 auto;\n          height: 86px;\n        }\n\n        .seconds-hovered-time {\n          display: flex;\n          position: absolute;\n          bottom: 0;\n          padding: 4px 12px;\n          align-items: flex-start;\n          gap: 10px;\n          align-self: stretch;\n          border-radius: 4px;\n          border: 1px solid #FFF;\n          background: #EAECF0;\n          box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.25);\n          color: #151010;\n          text-align: center;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 100%; /* 14px */\n          z-index: 10;\n        }\n      }\n\n      .hover-dot {\n        position: absolute;\n        top: 11px;\n        height: 12px;\n        width: 12px;\n        margin-left: 77px;\n        background-color: #fff;\n        border-radius: 50%;\n        z-index: 100;\n        pointer-events: none;\n      }\n\n      .display-player-button {\n        width: 24px;\n        height: 24px;\n        margin-top: 6px;\n        margin-left: 10px;\n        margin-right: 6px;\n        cursor: pointer;\n      }\n\n      .display-progress-bar {\n        width: 565px;\n        height: 8px !important;\n      }\n\n      .slider-wrapper {\n        margin-top: 13px;\n        width: 565px;\n        height: 8px !important;\n      }\n\n      .display-progress-bar:hover {\n        background: transparent;\n      }\n\n      .slider-track {\n        height: 8px;\n        background: color.$white;\n        border: 1px solid color.$white;\n      }\n\n      .slider-thumb {\n        background: color.$white;\n        color: color.$white;\n        box-shadow: none;\n      }\n\n      .slider-thumb::before {\n        box-shadow: none;\n      }\n\n      .slider-rail {\n        height: 8px !important;\n        background: rgba(255, 255, 255, .5);\n      }\n      \n      .loop-time-remaining {\n        color: color.$white;\n        font-size: 12px;\n        margin-top: 12px;\n        margin-right: 14px;\n        margin-left: 2px;\n      }\n\n      .loop-total-time {\n        color: color.$white;\n        font-size: 12px;\n        margin-top: 12px;\n        margin-left: 14px;\n      }\n    }\n\n    .loop-media-navigation {\n      display: flex;\n      min-height: 34px;\n      margin-top: 16px;\n      margin-bottom: 16px;\n\n      .loop-right-button {\n        color: color.$primary;\n        margin-left: auto;\n        cursor: pointer;\n      }\n    }\n\n    .loop-media-carousel {\n      position: relative;\n      min-height: 93px;\n\n      .carousel-item-padding {\n        padding: 0 8px;\n      }\n\n      .react-multi-carousel-item {\n        max-width: 173px;\n      }\n\n      .media-item-download {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 8px;\n        margin-top: 8px;\n        font-size: 12px;\n        color: color.$primary;\n\n        > .label {\n          flex-grow: 1;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n\n      .loop-left-button {\n        position: absolute;\n        color: color.$primary;\n        left: 16px;\n        top: 32px;\n      }\n\n      .loop-right-button {\n        position: absolute;\n        color: color.$primary;\n        left: 800px;\n        top: 32px;\n      }\n\n      .carousel-button-group {\n        position: absolute;\n        width: 100%;\n        top: 0;\n        display: flex;\n        justify-content: space-between;\n\n        .loop-left-button {\n          color: color.$primary;\n          margin-top: 30px;\n          cursor: pointer;\n        }\n\n        .loop-right-button {\n          color: color.$primary;\n          margin-top: 30px;\n          cursor: pointer;\n        }\n      }\n    }\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
export var primary = `#333F48`;
export var secondary = `#222732`;
export var yellow = `#FECF0C`;
export var red = `#E02D4F`;
export var teal = `#23CCC3`;
export var orange = `#F66733`;
export var lightGray = `#F6F6F6`;
export var whiteSmoke = `#E1E1E9`;
export var manatee = `#959AAD`;
export var obsidian = `#383838`;
export var success = `#00A474`;
export var warning = `#FFC107`;
export var error = `#CF0838`;
export var white = `#FFFFFF`;
export var black = `#000000`;
export var gray = `#757575`;
export var darkGray = `#A4A7B7`;
export var mediumGray = `#E0E0E0`;
export var lighterGray = `#E3E7F4`;
export var lightSlateGray = `#8A8FA3`;
export var carrot = `#FF892E`;
export var lightSmoke = `#F5F4F5`;
export var graphBlue = `#1570EF`;
export var lightOrchid = `#7F56D9`;
export var rainboots = `#3361E1`;
export var royalBlue = `#4085DE`;
export var sushi = `#95C653`;
export var primaryButtonBackground = `#FECF0C`;
export var primaryButtonText = `#333F48`;
export var secondaryButtonBackground = `#333F48`;
export var secondaryButtonText = `#FFFFFF`;
export var navigationText = `#95A3AD`;
export var scheduleMusic = `#FCC7B3`;
export var scheduleMessageBlock = `#23CCC3`;
export var scheduleInterrupt = `#1997A3`;
export var scheduleLoop = `#333F48`;
export var primary16 = `rgba(51, 63, 72, 0.16)`;
export var primary40 = `rgba(51, 63, 72, 0.4)`;
export var primary50 = `rgba(51, 63, 72, 0.5)`;
export var primary60 = `rgba(51, 63, 72, 0.6)`;
export var secondary25 = `rgba(34, 39, 50, 0.25)`;
export var secondary50 = `rgba(34, 39, 50, 0.5)`;
export var secondary75 = `rgba(34, 39, 50, 0.75)`;
export var yellow16 = `rgba(254, 207, 12, 0.16)`;
export var yellow25 = `rgba(254, 207, 12, 0.25)`;
export var yellow75 = `rgba(254, 207, 12, 0.75)`;
export var orange16 = `rgba(246, 103, 51, 0.16)`;
export var orange32 = `rgba(246, 103, 51, 0.32)`;
export var orange50 = `rgba(246, 103, 51, 0.5)`;
export var orange75 = `rgba(246, 103, 51, 0.75)`;
export var manatee16 = `rgba(149, 154, 173, 0.16)`;
export var manatee50 = `rgba(149, 154, 173, 0.5)`;
export var success10 = `rgba(0, 164, 116, 0.08)`;
export var success16 = `rgba(0, 164, 116, 0.16)`;
export var success75 = `rgba(0, 164, 116, 0.75)`;
export var warning50 = `rgba(255, 193, 7, 0.5)`;
export var error10 = `rgba(207, 8, 56, 0.1)`;
export var error16 = `rgba(207, 8, 56, 0.16)`;
export var error20 = `rgba(207, 8, 56, 0.2)`;
export var error50 = `rgba(207, 8, 56, 0.5)`;
export var error75 = `rgba(207, 8, 56, 0.75)`;
export var error85 = `rgba(207, 8, 56, 0.85)`;
export var gray50 = `#F9FAFB`;
export var gray200 = `#EAECF0`;
export var gray300 = `#D0D5DD`;
export var gray400 = `#98A2B3`;
export var gray500 = `#667085`;
export var gray700 = `#344054`;
export var gray900 = `#101828`;
export var carrot16 = `rgba(255, 137, 46, 0.16)`;
export var rainboots16 = `rgba(51, 97, 225, 0.16)`;
export var royalBlue16 = `rgba(64, 133, 222, 0.16)`;
export var boxPurple16 = `rgba(109, 109, 181, 0.16)`;
export var boxRed = `#E02D4F`;
export var boxPink = `#F57A7A`;
export var boxOrange = `#F66733`;
export var boxYellow = `#FECF0C`;
export var boxGreen = `#95C653`;
export var boxDarkGreen = `#00A474`;
export var boxBlue = `#33ACE1`;
export var boxDarkBlue = `#3361E1`;
export var boxPurple = `#6D6DB5`;
export var boxDarkPurple = `#332A4B`;
export default ___CSS_LOADER_EXPORT___;
